import { all, call, put, takeLatest } from "redux-saga/effects"
import { GET_JOB_SITES , GET_VIDEO, SIGNATURE,SIGNATURE_STATUS} from "./types"
import { getJobSitesFailure, getJobSitesSuccess, getVideoSuccess,getVideoFailure,signatureFailure,signatureSuccess,checkSignatureStatusSuccess,checkSignatureStatusFailure  } from "./actions"
import UXR from '../../../../utils/XHR'
import { BASE_URL } from "../../../../config/app"
import { take } from "lodash"



async function GetJobSiteAPI() {
    const token = await sessionStorage.getItem("token")
    const URL = `${BASE_URL}/api/v1/jobsite/`
    const options = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Token " + token
      },
      method: "GET"
    }
  
    return UXR(URL, options)
  }
  
function* GetJobSites() {
    try {
      const res = yield call(GetJobSiteAPI)
      yield put(getJobSitesSuccess(res.data))
    } catch (e) {
      // mapErrors(e)
      yield put(getJobSitesFailure(e.response))
    }
}

async function GetVideoAPI() {
  const token = await sessionStorage.getItem("token")
  const URL = `${BASE_URL}/api/v1/videos/`
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token
    },
    method: "GET"
  }

  return UXR(URL, options)
}

function* GetVideo() {
  try {
    const res = yield call(GetVideoAPI)
    yield put(getVideoSuccess(res.data))
  } catch (e) {
    // mapErrors(e)
    yield put(getVideoFailure(e.response))
  }
}

async function signatureAPI(data) {
  const token = await sessionStorage.getItem("token")
  const URL = `${BASE_URL}/api/v1/signature/`
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Token ${token}`
    },
    method: "POST",
    data
  }

  return UXR(URL, options)
}

function* signature({ data, id,meeting_id }) {
  try {
    const res = yield call(signatureAPI, data, id)
    yield put(signatureSuccess(res.data))
  } catch (e) {
    // mapErrors(e)
    yield put(signatureFailure(e.response))
  }
}


async function getSignatureAPI({id,meeting_id }) {
  const token = await sessionStorage.getItem("token")
  const URL = `${BASE_URL}/api/v1/signature/?video_id=${id}&meeting_id=${meeting_id}`
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token
    },
    method: "GET"
  }

  return UXR(URL, options)
}


function* getSignatureStatus({id,meeting_id}) {
  try {
    const res = yield call(getSignatureAPI, {id, meeting_id})
    if(res?.data?.[0]?.signature){
      yield put(checkSignatureStatusSuccess(res.data[0].signature))
     // yield put(setTotalPoints(res.data[0].total_points))
    }
   
  } catch (e) {
    //mapErrors(e)
    yield put(checkSignatureStatusFailure(e.response))
  }
}

export default all([takeLatest(GET_JOB_SITES, GetJobSites) ,takeLatest(GET_VIDEO, GetVideo),takeLatest(SIGNATURE, signature), takeLatest(SIGNATURE_STATUS, getSignatureStatus)])



